import React, { useState } from 'react';
import { collection, doc, updateDoc, query, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const AdminReferralPanel = () => {
    const [password, setPassword] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [referrals, setReferrals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('requested'); // Default to requested

    const ADMIN_PASSWORD = "admin123";

    const handleLogin = () => {
        if (password === ADMIN_PASSWORD) {
            setIsAuthenticated(true);
            fetchReferrals();
        } else {
            alert("Invalid password");
        }
    };

    const fetchReferrals = async () => {
        setLoading(true);
        try {
            const referralsRef = collection(db, "referrals");
            const q = query(referralsRef);

            const unsubscribe = onSnapshot(q, (snapshot) => {
                const referralsData = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                console.log("Loaded referrals for admin:", referralsData);
                setReferrals(referralsData);
                setLoading(false);
            });

            return unsubscribe;
        } catch (error) {
            console.error("Error fetching referrals:", error);
            setLoading(false);
        }
    };

    // ✅ SIMPLIFIED: Direct mark as paid
    const markWithdrawalAsPaid = async (referralId) => {
        try {
            const referralRef = doc(db, "referrals", referralId);
            await updateDoc(referralRef, {
                withdrawPaid: true,
                paidAt: new Date(),
                status: "paid"
            });

            alert("✅ Payment recorded successfully!");
        } catch (error) {
            console.error("Error updating withdrawal:", error);
            alert("❌ Failed to update payment status");
        }
    };

    // ✅ BULK ACTION: Mark multiple as paid
    const bulkMarkAsPaid = async (referralIds) => {
        try {
            const promises = referralIds.map(id =>
                updateDoc(doc(db, "referrals", id), {
                    withdrawPaid: true,
                    paidAt: new Date(),
                    status: "paid"
                })
            );

            await Promise.all(promises);
            alert(`✅ ${referralIds.length} payments recorded successfully!`);
        } catch (error) {
            console.error("Error in bulk update:", error);
            alert("❌ Failed to update some payments");
        }
    };

    const getFilteredReferrals = () => {
        switch (filter) {
            case 'requested':
                return referrals.filter(ref => ref.withdrawRequested && !ref.withdrawPaid);
            case 'paid':
                return referrals.filter(ref => ref.withdrawPaid);
            case 'completed':
                return referrals.filter(ref => !ref.withdrawRequested && !ref.withdrawPaid);
            default:
                return referrals;
        }
    };

    const calculateTotalCommission = (referralsList) => {
        return referralsList.reduce((total, ref) => total + (ref.commission || 0), 0);
    };

    const calculatePendingPayout = () => {
        const requested = referrals.filter(ref => ref.withdrawRequested && !ref.withdrawPaid);
        return requested.reduce((total, ref) => total + (ref.commission || 0), 0);
    };

    // ✅ Get referrals that can be processed in bulk
    const getBulkProcessableReferrals = () => {
        return referrals.filter(ref => ref.withdrawRequested && !ref.withdrawPaid && ref.referrerUPI);
    };

    if (!isAuthenticated) {
        return (
            <div style={{ padding: "20px", maxWidth: "400px", margin: "50px auto", textAlign: "center" }}>
                <h2>Admin Login</h2>
                <input
                    type="password"
                    placeholder="Enter admin password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        width: '100%',
                        marginBottom: '15px'
                    }}
                />
                <button
                    onClick={handleLogin}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Login
                </button>
            </div>
        );
    }

    const filteredReferrals = getFilteredReferrals();
    const bulkProcessable = getBulkProcessableReferrals();

    return (
        <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h1>Referral Admin Panel</h1>
                <button
                    onClick={() => setIsAuthenticated(false)}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Logout
                </button>
            </div>

            {/* ✅ Stats Overview */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#e8f5e8', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                    <h3>Total Referrals</h3>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#2e7d32' }}>{referrals.length}</p>
                </div>
                <div style={{ backgroundColor: '#fff3cd', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                    <h3>Pending Payout</h3>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#856404' }}>₹{calculatePendingPayout()}</p>
                </div>
                <div style={{ backgroundColor: '#d4edda', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                    <h3>Total Paid</h3>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#155724' }}>
                        ₹{calculateTotalCommission(referrals.filter(ref => ref.withdrawPaid))}
                    </p>
                </div>
                <div style={{ backgroundColor: '#d1ecf1', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                    <h3>Ready to Pay</h3>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#0c5460' }}>
                        {bulkProcessable.length}
                    </p>
                </div>
            </div>

            {/* ✅ Bulk Action */}
            {bulkProcessable.length > 0 && (
                <div style={{ backgroundColor: '#e7f3ff', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
                    <h4>💰 Bulk Payment Action</h4>
                    <p>
                        <strong>Total for bulk payment:</strong> ₹{calculateTotalCommission(bulkProcessable)}
                        ({bulkProcessable.length} referrals)
                    </p>
                    <button
                        onClick={() => {
                            const upiList = [...new Set(bulkProcessable.map(ref => ref.referrerUPI))];
                            const totalAmount = calculateTotalCommission(bulkProcessable);

                            alert(`💰 Send total ₹${totalAmount} to these UPI IDs:\n\n${upiList.join('\n')}\n\nAfter sending all payments, click OK to mark all as paid.`);
                            bulkMarkAsPaid(bulkProcessable.map(ref => ref.id));
                        }}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#28a745',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Mark All as Paid (₹{calculateTotalCommission(bulkProcessable)})
                    </button>
                </div>
            )}

            {/* ✅ Filter Controls */}
            <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button
                    onClick={() => setFilter('requested')}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: filter === 'requested' ? '#ffc107' : '#f8f9fa',
                        color: filter === 'requested' ? 'black' : 'black',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Withdrawal Requested ({referrals.filter(ref => ref.withdrawRequested && !ref.withdrawPaid).length})
                </button>
                <button
                    onClick={() => setFilter('paid')}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: filter === 'paid' ? '#28a745' : '#f8f9fa',
                        color: filter === 'paid' ? 'white' : 'black',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Paid ({referrals.filter(ref => ref.withdrawPaid).length})
                </button>
                <button
                    onClick={() => setFilter('completed')}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: filter === 'completed' ? '#17a2b8' : '#f8f9fa',
                        color: filter === 'completed' ? 'white' : 'black',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    No Request ({referrals.filter(ref => !ref.withdrawRequested && !ref.withdrawPaid).length})
                </button>
                <button
                    onClick={() => setFilter('all')}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: filter === 'all' ? '#007bff' : '#f8f9fa',
                        color: filter === 'all' ? 'white' : 'black',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    All Referrals ({referrals.length})
                </button>
            </div>

            {loading ? (
                <p>Loading referrals...</p>
            ) : (
                <div>
                    {filteredReferrals.length === 0 ? (
                        <p style={{ textAlign: 'center', padding: '20px', color: '#6c757d' }}>
                            No referrals found for the selected filter.
                        </p>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Referrer Code</th>
                                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Friend Details</th>
                                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Date</th>
                                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Commission</th>
                                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Status</th>
                                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Referrer UPI</th>
                                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredReferrals.map((referral) => (
                                        <tr key={referral.id}>
                                            <td style={{ padding: '12px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                                                {referral.referrerCode}
                                            </td>
                                            <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                                <div>
                                                    <strong>{referral.friendName}</strong><br />
                                                    <small>{referral.friendEmail}</small>
                                                </div>
                                            </td>
                                            <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                                {new Date(referral.createdAt?.toDate?.() || referral.createdAt).toLocaleDateString()}
                                            </td>
                                            <td style={{ padding: '12px', border: '1px solid #ddd', fontWeight: 'bold', color: 'green' }}>
                                                ₹{referral.commission}
                                            </td>
                                            <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                                <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '12px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    backgroundColor:
                                                        referral.withdrawPaid ? '#d4edda' :
                                                            referral.withdrawRequested ? '#fff3cd' : '#e8f5e8',
                                                    color:
                                                        referral.withdrawPaid ? '#155724' :
                                                            referral.withdrawRequested ? '#856404' : '#2e7d32'
                                                }}>
                                                    {referral.withdrawPaid ? 'PAID' :
                                                        referral.withdrawRequested ? 'REQUESTED' : 'COMPLETED'}
                                                </span>
                                            </td>
                                            <td style={{ padding: '12px', border: '1px solid #ddd', fontFamily: 'monospace' }}>
                                                {referral.referrerUPI || 'Not provided'}
                                            </td>
                                            <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                                                {referral.withdrawRequested && !referral.withdrawPaid && (
                                                    <button
                                                        onClick={() => {
                                                            const upiId = referral.referrerUPI || 'Not provided';
                                                            if (!referral.referrerUPI) {
                                                                alert(`⚠️ No UPI ID provided! Contact the user: ${referral.friendEmail}`);
                                                                return;
                                                            }
                                                            alert(`💰 Send ₹${referral.commission} to UPI: ${upiId}\n\nAfter sending money, click OK to mark as paid.`);
                                                            markWithdrawalAsPaid(referral.id);
                                                        }}
                                                        style={{
                                                            padding: '6px 12px',
                                                            backgroundColor: '#28a745',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        Mark as Paid
                                                    </button>
                                                )}
                                                {referral.withdrawPaid && (
                                                    <span style={{ color: '#28a745', fontWeight: 'bold' }}>✅ Paid</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AdminReferralPanel;